import { COURT_FINDER_PAGE } from 'constants/pages';
import { MyCourtsProps } from 'screens/PlayerLoggedInScreen/props';
import CardsSection from 'components/CardSection';
import CardVenue from 'components/cards/CardVenue';
import classNames from 'styles/utils/classNames';
import EmptyState from '../EmptyState';
import IconActionLink from 'components/IconActionLink';

const MyCourts: React.FC<MyCourtsProps> = ({ venues, loading }) => {
  return (
    <div
      className={classNames(
        'container mx-auto mt-[1.6rem] border-b border-color-bg-input-lightmode-primary pb-ds-2xl dark:border-color-bg-input-darkmode-primary max-sm:pl-4',
        venues.length > 0 ? 'max-sm:pl-4' : 'max-sm:px-4',
      )}
    >
      <h3 className="max-sm:typography-product-heading-mobile typography-product-heading-desktop mb-5 max-sm:mb-3">
        My Courts
      </h3>
      {!loading && venues.length === 0 && (
        <EmptyState
          href={COURT_FINDER_PAGE}
          title="Find & book Courts"
          text="You don’t have Courts you follow yet."
        />
      )}
      <CardsSection
        scrollOffset={{
          base: 0,
          xs: 100,
          lg: 0,
        }}
        visibleCards={{
          base: 1,
          xs: 1,
          md: 2,
          lg: 3,
          xxl: 4,
        }}
        loading={loading}
        gap="1rem"
        data={venues}
        renderCard={(venue, index) => (
          <CardVenue
            homePage
            key={venue.id}
            id={venue.id}
            slug={venue.slug}
            imageUrl={venue?.images?.[0]?.url}
            title={venue.title}
            addressString={venue.addressString}
            accessType={venue.accessType}
            totalCourtCount={venue.indoorCourtCount + venue.outdoorCourtCount}
            pickleballNets={venue.pickleballNets}
          />
        )}
        affix={<IconActionLink title="Find new Court" className="pl-12" href={COURT_FINDER_PAGE} />}
      />
    </div>
  );
};

export default MyCourts;
